/*
 * View for showing generated intent examples list from a custom utterance.
 */

define([
  "marionette",
  "configuration/properties",
  "modules/topicsSplit/topic/topicExampleGeneratorModal/topicExampleGeneratedList/template/topicExampleGeneratedListTemplate.html",
], function (Marionette, Properties, TopicExampleGeneratedListTemplate) {
  let TopicExampleGeneratedListView = {};

  TopicExampleGeneratedListView.topicExampleGeneratedListView = Marionette.ItemView.extend({
    template: TopicExampleGeneratedListTemplate,
    modelEvents: {
      sync: "render",
    },
    events: {
      "change input.generated_example_checkbox": "exampleSelected",
    },
    exampleSelected: function (e) {
      this.trigger("restrict:selected:examples", e);
    },
  });

  return TopicExampleGeneratedListView;
});
